<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<a id="page_5">
<p class="chap-title" style="font-size:2.5em; margin-top:2em!important;margin-bottom:1em!important;">C<span class="small">ONTENTS</span></p>
</a><p class="paranoindent1" id="intro"><a id="page_5"></a><a href="#/text/06_introduction#intro">Introduction</a></p>
<p class="list-item1" style="margin-top:1em!important;"><span class="label"><a href="#/text/07_chapter1#ch1" id="ch1"><big><b>1</b></big></a></span> <a href="#/text/07_chapter1#ch1"><big>Inception and Design</big></a></p>
<p class="paranoindent1"> </p>
<p class="list-item1"><span class="label"><a href="#/text/08_chapter2#ch2" id="ch2"><big><b>2</b></big></a></span> <a href="#/text/08_chapter2#ch2"><big>Layout and Build</big></a></p>
<p class="paranoindent1"> </p>
<p class="list-item1"><span class="label"><span href="#/text/09_chapter3#ch3" id="ch3" title="Link target outside of Sample"><big><b>3</b></big></span></span> <span href="#/text/09_chapter3#ch3" title="Link target outside of Sample"><big>Crews</big></span></p>
<p class="paranoindent1"> </p>
<p class="list-item1"><span class="label"><span href="#/text/10_chapter4#ch4" id="ch4" title="Link target outside of Sample"><big><b>4</b></big></span></span> <span href="#/text/10_chapter4#ch4" title="Link target outside of Sample"><big>Parent Ships</big></span></p>
<p class="paranoindent1"> </p>
<p class="list-item1"><span class="label"><span href="#/text/11_chapter5#ch5" id="ch5" title="Link target outside of Sample"><big><b>5</b></big></span></span> <span href="#/text/11_chapter5#ch5" title="Link target outside of Sample"><big>Techniques and Tactics</big></span></p>
<p class="paranoindent1"> </p>
<p class="list-item1"><span class="label"><span href="#/text/12_chapter6#ch6" id="ch6" title="Link target outside of Sample"><big><b>6</b></big></span></span> <span href="#/text/12_chapter6#ch6" title="Link target outside of Sample"><big>The Army On Board</big></span></p>
<p class="paranoindent1"> </p>
<p class="list-item1"><span class="label"><span href="#/text/13_chapter7#ch7" id="ch7" title="Link target outside of Sample"><big><b>7</b></big></span></span> <span href="#/text/13_chapter7#ch7" title="Link target outside of Sample"><big>Specialist Craft and Roles</big></span></p>
<p class="paranoindent1"> </p>
<p class="list-item1"><span class="label"><span href="#/text/14_chapter8#ch8" id="ch8" title="Link target outside of Sample"><big><b>8</b></big></span></span> <span href="#/text/14_chapter8#ch8" title="Link target outside of Sample"><big>Operations</big></span></p>
<p class="paranoindent1"> </p>
<p class="paranoindent1" id="note"><span href="#/text/15_notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="paranoindent1" id="source"><span href="#/text/16_sources#source" title="Link target outside of Sample">Sources</span></p>
<p class="paranoindent1" id="ind"><span href="#/text/17_index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_toc.vue?73996ccd